import React, { useState } from "react";

const useNavDrawer = () => {
  const [drawer, setDrawer] = useState(false);

  function toggleDrawer(open) {
    return (event) => {
      setDrawer(open);
    };
  }

  return {
    drawer,
    toggleDrawer,
  };
};

export default useNavDrawer;
